import { useTranslation } from 'react-i18next';
import type { BankTransferProcessStatus } from '../types/bankTransfer';

interface BankTransferStatusBadgeProps {
  readonly status: BankTransferProcessStatus;
}

const STATUS_STYLES: Record<BankTransferProcessStatus, string> = {
  AWAITING_TRANSFER: 'bg-amber-100 text-amber-700',
  DECLARED_AWAITING_SETTLEMENT: 'bg-blue-100 text-blue-700',
  DEPOSIT_CONFIRMED: 'bg-green-100 text-green-700',
  AWAITING_BALANCE: 'bg-teal-100 text-teal-700',
  COMPLETED: 'bg-gray-100 text-gray-600',
  EXPIRED: 'bg-red-100 text-red-600',
  LATE_FUNDS_REVIEW: 'bg-orange-100 text-orange-700',
  REFUND_REQUIRED: 'bg-red-100 text-red-700',
  CANCELLED: 'bg-gray-100 text-gray-500',
};

export const BankTransferStatusBadge = ({ status }: BankTransferStatusBadgeProps) => {
  const { t } = useTranslation('badges');

  const STATUS_LABELS: Record<BankTransferProcessStatus, string> = {
    AWAITING_TRANSFER: t('bankTransferAwaitingTransfer'),
    DECLARED_AWAITING_SETTLEMENT: t('bankTransferDeclaredAwaitingSettlement'),
    DEPOSIT_CONFIRMED: t('bankTransferDepositConfirmed'),
    AWAITING_BALANCE: t('bankTransferAwaitingBalance'),
    COMPLETED: t('bankTransferCompleted'),
    EXPIRED: t('bankTransferExpired'),
    LATE_FUNDS_REVIEW: t('bankTransferLateFundsReview'),
    REFUND_REQUIRED: t('bankTransferRefundRequired'),
    CANCELLED: t('bankTransferCancelled'),
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${STATUS_STYLES[status]}`}
    >
      {STATUS_LABELS[status]}
    </span>
  );
};
